import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ChunkedUploader from "./ChunkedUploader";

const toaster = ReactDOM.createRoot(document.getElementById("toaster")!);
toaster.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const dropzone = ReactDOM.createRoot(document.getElementById("dropzone")!);
//dropzone.render(<Dropzone />);
dropzone.render(<ChunkedUploader />);
